import React, { useState } from "react";
import BillToPay from "./BillToPay";
import BillSelectTip from "./BillSelectTip";
import BillNumberOfPersons from "./BillNumberOfPersons";
import BillTotal from "./BillTotal";
import "./BillContainer.css";

export default function BillContainer() {
  const [billTotalRunnig, setBillTotalRunning] = useState("0");
  const [billAmout, setBillAmout] = useState(0);
  const [numberOfPeople, setNumberOfPeople] = useState(1);
  const [tipAmount, setTipAmount] = useState(0);

  const billAmountHandler = (getAmount) => {
    setBillAmout(getAmount);
    setBillTotalRunning(+getAmount);
  };

  const selectTipHandler = (getTip) => {
    setTipAmount(getTip);
  };

  const selectNumOfPeopleHandler = (numOfPeople) => {
    setNumberOfPeople(numOfPeople);
  };

  const resetHandler = () => {
    setBillTotalRunning(0);
    setBillAmout(0);
    setNumberOfPeople(1);
    setTipAmount(0);
  };

  const calTip = () => (billTotalRunnig * tipAmount) / 100 / numberOfPeople;
  const calTotal = () => (billTotalRunnig + calTip()) / numberOfPeople;

  return (
    <div className="bill-container">
      <div className="desktop-left">
        <BillToPay billAmount={billAmout} onBillAmount={billAmountHandler} />
        <BillSelectTip
          onSelectTip={selectTipHandler}
          onChange={selectTipHandler}
          tipAmount={tipAmount}
        />
        <BillNumberOfPersons
          numberOfPeople={numberOfPeople}
          onSelectNumOfPeople={selectNumOfPeopleHandler}
        />
      </div>
      <div className="desktop-rigth">
        <BillTotal
          tipAmount={calTip().toFixed(2)}
          billTotalRunnig={calTotal().toFixed(2)}
          onReset={resetHandler}
        />
      </div>
    </div>
  );
}
